import lf from "localforage";
import APIFunction from "../service-workers/common";
import fileutility from "../src/old/fileutility";
import msg from "./msg";

let triggered = false;

const lf_files_keys = lf.createInstance({name: "wip_localfiles-keys"});
const lf_files_links = lf.createInstance({name: "wip_localfiles-links"});
const lf_files_filefieldsupdated = lf.createInstance({name: "wip_localfiles-filefieldsupdated"});

const lf_files_data = lf.createInstance({name: "wip_localfiles_data"});
const lf_fields_to_update = lf.createInstance({name: "wip_data_to_update"});

import UFNV from "./uploadfilenew";

const highestId = setTimeout(() => {
	for (let i = highestId; i >= 0; i--) {
		clearInterval(i);
	}
}, 0);

async function PromisesAll(promises) {
	return Promise.allSettled(
		promises.map((p) => {
			return p
				.then((value) => {
					return {
						status: "fulfilled",
						value,
					};
				})
				.catch((reason) => {
					return {
						status: "rejected",
						reason,
					};
				});
		})
	);
}

async function APIAction(url, data) {
	return new Promise((resolve) => {
		APIFunction(url, data)
			.then((r) => {
				resolve(r);
			})
			.catch((e) => {
				console.log(e);
			});
	});
}

const fileExists = async (file) => {
	// console.log("checking if file exists", file);
	let response = await fetch(file, {method: "HEAD", cache: "no-store"});
	let result = response.status == 200; //{200: true, 404: false}[response.status];
	// console.log("checked file", {file, response, result});
	return result;
};

async function WorkAsync() {
	// console.log("backend work async");
	let datakeys = await lf_fields_to_update.keys();
	await PromisesAll(
		datakeys.map((nf) => {
			return new Promise((resolve) => {
				lf_fields_to_update.getItem(nf).then((q) => {
					// console.log("updating backend", q.data);
					APIAction(q.url, q.data).then((r) => {
						if (r) {
							let result = r;
							// console.log("result", q.data, r);
							if (!result.success) {
								lf_fields_to_update.removeItem(nf);
								self.clients.matchAll().then((clients) => {
									clients.forEach((client) => client.postMessage(JSON.stringify({nf, result})));
								});
							}
						}
						resolve();
					});
				});
			});
		})
	);
}

function keyid(nf, id) {
	return `${nf}-${id}`;
}

async function ProcessFileField(nf) {
	let data = await lf_files_keys.getItem(nf);
	if (data) {
		// console.log({data});
		let keys = data.keys;
		let links = data.links;
		let value = data.value;
		if (!links) links = "";
		let newLinks = {};
		// console.log("received keys", data, data.keys, data.links);
		await PromisesAll(
			keys.map(async (k, i) => {
				//for each file individually, get link

				let checkitem = await lf_files_links.getItem(keyid(nf, k.id));
				if (!checkitem) {
					// console.log("this item doesn't exist", k.name, k.type, nf);
					let response = await APIAction("GetPresignedFileUploadRequest", {
						filename: k.name,
						contentType: k.type,
						nf,
					});
					k.uploadurl = JSON.parse(response.d).uploadurl;
					k.url = k.uploadurl.split("?")[0];

					await lf_files_links.setItem(keyid(nf, k.id), k);
				} else {
					k.uploadurl = checkitem.uploadurl;
					k.url = checkitem.url;
				}

				newLinks[k.id] = {
					url: k.url,
					caption: k.name,
				};

				// console.log(newLinks);
			})
		).then(async (_) => {
			newLinks = keys.map((k, i) => {
				return {
					url: newLinks[k.id].url,
					caption: newLinks[k.id].caption,
				};
			});
			// console.log({links, newLinks});
			let newArray = [...links, ...newLinks];
			let newval = newArray.map((a) => `${addQueryParamsToUrl(a.url, {filename: a.caption})}`).join(",");

			let result = await APIAction("UpdateValueForNF", {nf, value: newval, directsave: true});

			lf_files_filefieldsupdated.setItem(nf, data);

			await lf_files_keys.removeItem(nf);

			// console.log({links, newval, newArray});
		});

		return null;
	}
}

function addQueryParamsToUrl(url, params) {
	// if URL is relative, we'll need to add a fake base
	var fakeBase = !url.startsWith("http") ? "http://fake-base.com" : undefined;
	var modifiedUrl = new URL(url || "", fakeBase);

	// add/update params
	Object.keys(params).forEach(function (key) {
		if (modifiedUrl.searchParams.has(key)) {
			modifiedUrl.searchParams.set(key, params[key]);
		} else {
			modifiedUrl.searchParams.append(key, params[key]);
		}
	});

	// return as string (remove fake base if present)
	return modifiedUrl.toString().replace(fakeBase, "");
}

async function uploadFilesAsync() {
	// console.log("backend file async");
	// console.log("time to upload files");
	let filestoupload = await lf_files_filefieldsupdated.keys();

	// if (filestoupload.length == 0) console.log("no files");
	// else console.log("we have got files", filestoupload);

	await PromisesAll(
		filestoupload.map((nf) => {
			// console.log("nf pending", {nf});
			return new Promise((resolve) => {
				lf_files_filefieldsupdated.getItem(nf).then((data) => {
					if (data) {
						// console.log("found data", {data});
						let keys = data.keys;
						// console.log("found keys", {keys});
						let alldone = true;
						PromisesAll(
							keys.map((k) => {
								return new Promise((fileuploadchecked) => {
									lf_files_links.getItem(keyid(nf, k.id)).then((checkitem) => {
										let fileIsUploaded = false;
										if (checkitem) {
											lf_files_data.getItem(keyid(nf, k.id)).then((blobdata) => {
												if (blobdata) {
													let blob = fileutility.dataURLtoBlob(blobdata);

													//checking if file is already uploaded.

													// console.log("checkitem", {checkitem});
													fileExists(checkitem.url).then((yes) => {
														// console.log("after checking", {checkitem, yes});
														if (yes) {
															fileIsUploaded = true;
															lf_files_data.removeItem(keyid(nf, k.id));
															lf_files_links.removeItem(keyid(nf, k.id));
															fileuploadchecked();
														} else {
															fetch(checkitem.uploadurl, {
																method: "PUT",
																body: blob,
																fields: [],
																headers: {
																	"x-amz-acl": "public-read",
																},
															})
																.then((r) => {
																	// console.log("checkitem", {checkitem, r});
																	fileExists(checkitem.url).then((yes) => {
																		// console.log("after checking", {checkitem, yes});
																		if (yes) {
																			fileIsUploaded = true;
																			lf_files_data.removeItem(keyid(nf, k.id));
																			lf_files_links.removeItem(keyid(nf, k.id));
																		} else {
																			// console.log("File Upload Failed. Will Retry.");
																		}
																	});
																	// console.log("file uploaded", k.name);
																})
																.catch((e) => {
																	console.log("file upload error", k.name, e);
																});
														}
													});
												} else fileIsUploaded = true;
											});
										} else fileIsUploaded = true;

										if (!fileIsUploaded) alldone = false;
										fileuploadchecked();
									});
								});
							})
						).then((_) => {
							if (alldone) {
								lf_files_filefieldsupdated.removeItem(nf);
							}
							resolve();
						});
					} else {
						resolve();
					}
				});
			});
		})
	);
}

async function ProcessFileFields() {
	let step1Keys = await lf_files_keys.keys();

	if (step1Keys) {
		await PromisesAll(
			step1Keys.map((nf) => {
				return new Promise((resolve) => {
					ProcessFileField(nf).then(() => {
						resolve();
					});
				});
			})
		);
	}
}

const CallLoopFunction = (func, ms = 5000, maxCount = -1, funcRef = undefined) => {
	let ref = undefined;
	let counter = 0;
	let started = false;
	let running = false;

	function CreateNextFunction() {
		if (ref) clearTimeout(ref);
		if (maxCount == -1 || counter < maxCount) {
			ref = setTimeout(() => {
				// console.log("can't find this createcounter");
				CreateCounter();
			}, ms);
		} else {
			if (ref) clearTimeout(ref);
			// console.log("%cProgram Done Now. Will Exit", "background: #222; color: #bada55");
		}
	}

	const CreateCounter = async () => {
		if (ref) clearTimeout(ref);
		running = true;
		counter++;
		//console.log("%cProgram Ran Now.", "background: #222; color: #bada55", {counter});
		try {
			//if (funcRef) console.log("%cProgram Ran Now.", "background: #222; color: #bada55", {funcRef, counter});
			if (func) {
				await func();
			}
		} catch (exception) {
			console.log("Error in function", {funcRef, exception});
		} finally {
			CreateNextFunction();
			running = false;
		}
	};
	const Initiate = () => {
		if (!started) CreateCounter();
		else {
			if (!running) CreateCounter();
		}
		started = true;
	};

	return Initiate;
};

let loopWorkAsync;
let loopProcessFileFields;
let loopuploadFilesAsync;
let loopNewUPload;

function triggerbackendsync() {
	// console.count("triggered");

	//console.log({loopWorkAsync, loopProcessFileFields, loopuploadFilesAsync, loopNewUPload});

	// if (!workRepeat) work();
	// if (!processFileFieldRepeat) ProcessFileFields();
	// if (!uploadFileRepeat) uploadfiles();
	// if (!uploadfilenew) {
	// 	// console.log("before being set", {uploadfilenew});
	// 	//UploadFilesNewVersion();
	// }

	if (!loopWorkAsync)
		loopWorkAsync = CallLoopFunction(
			async () => {
				// console.log("%cWorking. Program 1", "background: #222; color: #bada55");
				// await Wait(3000);
				await WorkAsync();
			},
			15000,
			-1,
			"FieldUpdate"
		);
	loopWorkAsync();

	if (!loopProcessFileFields)
		loopProcessFileFields = CallLoopFunction(
			async () => {
				// console.log("%cWorking. Program 1", "background: #222; color: #bada55");
				// await Wait(3000);
				await ProcessFileFields();
			},
			15000,
			-1,
			"FileFields"
		);
	loopProcessFileFields();

	if (!loopuploadFilesAsync)
		loopuploadFilesAsync = CallLoopFunction(
			async () => {
				// console.log("%cWorking. Program 1", "background: #222; color: #bada55");
				// await Wait(3000);
				await uploadFilesAsync();
			},
			15000,
			-1,
			"FileSync"
		);
	loopuploadFilesAsync();

	if (!loopNewUPload)
		loopNewUPload = CallLoopFunction(
			async () => {
				// console.log("%cWorking. Program 1", "background: #222; color: #bada55");
				// await Wait(3000);
				await UFNV();
			},
			15000,
			-1,
			"New Upload"
		);
	loopNewUPload();
}

triggerbackendsync();

function triggerbackendsyncfromfrontend() {
	// console.log("file sync service started from frontend");
	// triggerbackendsync();
	msg.send("restartfileuploadprocesses", {}, "ts3");
}

function triggerbackendsyncfromserviceworker() {
	// console.log("file sync service started from service worker");
	triggerbackendsync();
}

function StartListeningToMessages() {
	// console.log("listening to messages");
	msg.listen("restartfileuploadprocesses", () => {
		triggerbackendsync();
	});
}
StartListeningToMessages();

function isTriggered() {
	return loopWorkAsync && loopProcessFileFields && loopuploadFilesAsync && loopNewUPload;
}

export {triggerbackendsyncfromfrontend, triggerbackendsyncfromserviceworker, isTriggered};
